module.exports = __webpack_public_path__ + "static/media/index.97b27180.less";